/* Flatpickr French locale */
flatpickr.l10ns.fr = {
  weekdays: {
    shorthand: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
    longhand: [
      "dimanche",
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi",
    ],
  },
  months: {
    shorthand: [
      "janv.",
      "févr.",
      "mars",
      "avr.",
      "mai",
      "juin",
      "juil.",
      "août",
      "sept.",
      "oct.",
      "nov.",
      "déc.",
    ],
    longhand: [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre",
    ],
  },
  firstDayOfWeek: 1,
  weekAbbreviation: "Sem",
  rangeSeparator: " au ",
  scrollTitle: "Faites défiler pour augmenter",
  toggleTitle: "Cliquer pour basculer",
  time_24hr: true,
};
